module.exports = __webpack_public_path__ + "media/images/icons/outlined/bank-92a91ce49503ccd99fbc511404731bc7.svg";